import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
// import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getPotencyBonus(params) {
	return client.get("binary/bonus/potency", {
		params: params,
	});
}

function getSummaryBonus(params) {
	return client.get("binary/bonus/summary", {
		params: params,
	});
}

function getBonusStatement(params) {
	return client.get("binary/bonus/statement", {
		params: params,
	});
}

function getHistoryBonusRO(params) {
	return client.get("binary/bonus/history/unilevel", {
		params: params,
	});
}

function getHistoryBonus(params) {
	return client.get("binary/bonus/history", {
		params: params,
	});
}

function getHistoryBonusTeam(params) {
	return client.get("binary/bonus/team/history", {
		params: params,
	});
}

function getHistoryClaim(params) {
	return client.get("binary/bonus/history-claim", {
		params: params,
	});
}

export default {
	getPotencyBonus,
	getSummaryBonus,
	getBonusStatement,
	getHistoryBonusRO,
	getHistoryBonus,
	getHistoryBonusTeam,
	getHistoryClaim,
};